export default __webpack_public_path__ + "static/media/Video.44ef0d47.svg";